const semanticClassNames = {
  root: 'text-particles',
  rootDone: 'text-particles--done',
} as const;

export default semanticClassNames;
